import { useAccount } from '../../features/onboarding/useAccount';
import type { PlanErrorFields } from '../../types/api';
import { brandLimitFields } from './planLabels';
import { usePlan } from './usePlan';

export interface BrandAllowance {
  /** Brands this account owns: what the plan's `brands` cap counts. */
  owned: number;
  /** The plan's cap, `null` when unlimited, `undefined` while the plan is unknown. */
  limit: number | null | undefined;
  /** True only when the plan is known and the account is at or past its cap. */
  atCap: boolean;
  /** The 402 fields an add would get, for the limit-mode Upsell. Null below the cap. */
  fields: PlanErrorFields | null;
}

/**
 * How many brands the account holds against its plan, for the add-brand
 * buttons. Brands the user is only a member of are someone else's allowance.
 *
 * Never "at cap" while the plan is unknown, so nothing is disabled during the
 * load; the server's 402 stays the enforcement either way.
 */
export function useBrandAllowance(): BrandAllowance {
  const { businesses } = useAccount();
  const { entitlements, limit: planLimit } = usePlan();
  const owned = businesses.filter((entry) => entry.role === 'owner').length;
  const limit = planLimit('brands');
  const atCap = entitlements !== null && typeof limit === 'number' && owned >= limit;
  return {
    owned,
    limit,
    atCap,
    fields:
      atCap && entitlements !== null && typeof limit === 'number'
        ? brandLimitFields(entitlements, limit)
        : null,
  };
}
